'use strict';

$ = jQuery;

/**
 * Cliques em leia Mais
 */
$(".jc-post-read-more-shortcode a").on('click', function () {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Post',
    'eventAction': 'Clique - Leia Mais',
    'eventLabel': $(this).text()
  });

  gtag('event', 'Post', {
    'eventAction': 'Clique - Leia Mais',
    'eventLabel': $(this).text()
  });
});